import { call, put, select, takeEvery } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getEntityCityTypeCombo from '../../services/dossier/get/getEntityCityTypeCombo'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchEntityCityTypeCombo ({ stateId, resolve }) {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    let combo = []
    if (stateId !== -1) {
      combo = yield call(getEntityCityTypeCombo, auth.token, stateId)
    }
    if (resolve) {
      resolve(combo)
    } else {
      yield put(fetchCombosSuccess({ entityCityTypeCombo: combo }))
    }
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchEntityCityTypeCombo () {
  yield takeEvery(combosActionTypes.FETCH_ENTITY_CITY_COMBO, fetchEntityCityTypeCombo)
}
